module.exports = __webpack_public_path__ + "static/media/sponsors_icon.1651ae63.png";